"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var d3 = require("d3");
var quantitativeScale_1 = require("./quantitativeScale");
var Log = /** @class */ (function (_super) {
    tslib_1.__extends(Log, _super);
    /**
     * @constructor
     */
    function Log(base) {
        if (base === void 0) { base = 10; }
        var _this = _super.call(this) || this;
        _this._d3Scale = d3.scaleLog().base(base);
        _this._setDomain(_this._defaultExtent());
        return _this;
    }
    Log.prototype._defaultExtent = function () {
        return [1, this._d3Scale.base()];
    };
    Log.prototype._expandSingleValueDomain = function (singleValueDomain) {
        if (singleValueDomain[0] === singleValueDomain[1]) {
            return [singleValueDomain[0] / this._d3Scale.base(),
                singleValueDomain[1] * this._d3Scale.base()];
        }
        return singleValueDomain;
    };
    Log.prototype.scale = function (value) {
        return this._d3Scale(value);
    };
    Log.prototype.scaleTransformation = function (value) {
        return this.scale(value);
    };
    Log.prototype.invertedTransformation = function (value) {
        return this.invert(value);
    };
    Log.prototype.getTransformationExtent = function () {
        return this._getUnboundedExtent(true);
    };
    Log.prototype.getTransformationDomain = function () {
        return this.domain();
    };
    Log.prototype.setTransformationDomain = function (domain) {
        this.domain(domain);
    };
    Log.prototype._getDomain = function () {
        return this._backingScaleDomain();
    };
    Log.prototype._backingScaleDomain = function (values) {
        if (values == null) {
            return this._d3Scale.domain();
        }
        else {
            this._d3Scale.domain(values);
            return this;
        }
    };
    Log.prototype._getRange = function () {
        return this._d3Scale.range();
    };
    Log.prototype._setRange = function (values) {
        this._d3Scale.range(values);
    };
    Log.prototype.invert = function (value) {
        return this._d3Scale.invert(value);
    };
    Log.prototype.defaultTicks = function () {
        return this._d3Scale.ticks(Log._DEFAULT_NUM_TICKS);
    };
    Log.prototype._niceDomain = function (domain, count) {
        return this._d3Scale.copy().domain(domain).nice().domain();
    };
    return Log;
}(quantitativeScale_1.QuantitativeScale));
exports.Log = Log;



//////////////////
// WEBPACK FOOTER
// ./src/scales/logScale.ts
// module id = 110
// module chunks = 0